import { useEffect, useRef } from 'react';

const TAMARA_WIDGET_SRC =
  'https://cdn-sandbox.tamara.co/widget-v2/tamara-widget.js';
const TAMARA_PUBLIC_KEY = '20d095a7-1e52-477c-8783-d2276590d6bb';

const TamaraWidget = ({ locale, amount }) => {
  const containerRef = useRef(null);
  const minvalue = process.env.NEXT_PUBLIC_TAMARA_MIN_VALUE;
  const maxvalue = process.env.NEXT_PUBLIC_TAMARA_MAX_VALUE;

  useEffect(() => {
    if (!document.querySelector(`script[src="${TAMARA_WIDGET_SRC}"]`)) {
      const script = document.createElement('script');
      script.src = TAMARA_WIDGET_SRC;
      script.defer = true;
      document.head.appendChild(script);
    }

    window.tamaraWidgetConfig = {
      lang: locale,
      country: 'SA',
      publicKey: TAMARA_PUBLIC_KEY,
      css: `
        .tamara-summary-widget__container { 
            justify-content: space-between !important; 
        }
      `,
    };

    if (containerRef.current) {
      const widget = document.createElement('tamara-widget');
      widget.setAttribute('type', 'tamara-summary');
      widget.setAttribute('amount', amount);
      widget.setAttribute('inline-type', '2');
      widget.setAttribute('inline-variant', 'outlined');

      containerRef.current.innerHTML = '';
      containerRef.current.appendChild(widget);
    }

    return () => {
      if (containerRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        containerRef.current.innerHTML = '';
      }
    };
  }, [locale, amount]);

  return amount >= +minvalue && amount <= +maxvalue ? (
    <div className='' ref={containerRef} />
  ) : null;
};

export default TamaraWidget;
